// extracted by mini-css-extract-plugin
export default {"inputT":"styles_inputT__euvih"};